import PCheckboxGroup from '@/package-admin/p-table/Chcekbox/src/checkbox-group.vue';

/* istanbul ignore next */
PCheckboxGroup.install = function (Vue) {
    Vue.component(PCheckboxGroup.name, PCheckboxGroup);
};

export default PCheckboxGroup;
